import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useModuleName } from '../../../hooks';
import { useDynamicReportApi } from '../../../services/api/dynamicReportApi/useDynamicReportApi';
import { COMPONENT_STATUS } from '../../../services/constants';
import { setReportDataStatus } from '../../campaigns/modules/campaigns-reports/actions';
import { addIndication, INDICATION_TYPES } from '../../taboola-common-frontend-modules/Indications';
import { useAccount } from '../../taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../taboola-common-frontend-modules/i18n';
import { MODULE_NAME as SCHEDULED_REPORTS_MODULE_NAME } from '../config/routes/module';
import {
    fetchAndTransformMetaModel,
    getMetaModelQueryKey,
    METAMODEL_QUERY_OPTIONS,
} from '../utils/fetchAndTransformMetaModel';
import { useAvailableDynamicReport } from './useAvailableDynamicReport';
import { useMetaModelExcludeNodeList } from './useMetaModelExcludeNodeList';

export const META_MODEL_TYPE_PERFORMANCE = 'PERFORMANCE';

const getErrorIndication = messageId => ({
    message: <FormattedMessage id={messageId} />,
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="error.highlight" />,
});

export const useDynamicReportMetaModel = metaModelType => {
    const { accountName } = useAccount();
    const dispatch = useDispatch();
    const dynamicReportApi = useDynamicReportApi();
    const isAllowedOnAccount = useAvailableDynamicReport();
    const moduleName = useModuleName();
    const enabled =
        !!metaModelType && !!accountName && isAllowedOnAccount && moduleName === SCHEDULED_REPORTS_MODULE_NAME;
    const excludeNodeList = useMetaModelExcludeNodeList();

    const { data, isSuccess } = useQuery(
        getMetaModelQueryKey(accountName),
        () => fetchAndTransformMetaModel({ dynamicReportApi, accountName, metaModelType, excludeNodeList }),
        {
            onError: () => {
                dispatch(setReportDataStatus(COMPONENT_STATUS.ERROR));
                dispatch(addIndication(getErrorIndication('dynamic.reports.dynamic.report.metamodel.fetch.failure')));
            },
            enabled,
            ...METAMODEL_QUERY_OPTIONS,
        }
    );

    return {
        isSuccess: isSuccess && enabled,
        metaModel: data,
    };
};
